import {DocRenderer} from '@cyntler/react-doc-viewer';
import {Buffer} from 'buffer';
import RtfViewer from '../CustomViewers/RTFViewer';

const RTFRenderer: DocRenderer = ({mainState: {currentDocument}}) => {
  const bufferData = currentDocument?.uri?.replace(
    'data:image/rtf;base64,',
    ''
  );
  if (bufferData) {
    try {
      const buffer = Buffer.from(bufferData, 'base64');
      return (
        <div style={{minWidth: '45vw'}}>
          <RtfViewer rtfBuffer={buffer} />
        </div>
      );
    } catch (error) {
      console.error('Error decoding Base64 string:', error);
      // Handle the error case, e.g., display an error message
      return <div>Error loading TIFF viewer</div>;
    }
  } else {
    // Handle the case where bufferData is undefined
    // For example, you might want to display a loading message or placeholder
    return <div>Loading...</div>;
  }
};

RTFRenderer.fileTypes = ['rtf', 'RTF', 'image/rtf'];
RTFRenderer.weight = 1;

export default RTFRenderer;
